<template>
  <div class="dropdown-body dropdown-body_fit">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'DropdownMenu',
  };
</script>
